import styled from 'styled-components';

export const ExternalUrlContainer = styled.div`
	padding: 1rem;
	color: #fff;
	div {
		background-color: rgb(37, 114, 38);
		padding: 1.5rem 2rem;
		border-radius: 20px;

		h4 {
			margin: 0 0 0.5rem;
		}

		p {
			margin: 0;
			font-size: 0.875rem;
			em {
				text-align: center;
				font-size: 0.75rem;
				width: 100%;
				display: inline-block;
			}
		}

		a {
			text-align: center;
			background-color: var(--ion-color-success);
			width: 100%;
			text-decoration: none;
			display: flex;
			gap: 0.5rem;
			align-items: center;
			justify-content: center;
			padding: 0.5rem;
			margin: 1rem 0 0.5rem;
			border-radius: 5px;
			color: #000;
			ion-icon {
				font-size: 1.25rem;
			}
		}
	}
`;
